export const BRAND = {
  name: "Laxmi Jiwan Properties",
  tagline: "Your Trusted Partner in Real Estate",
  city: "Hisar",
  state: "Haryana",
  address: "GF, 1115, Phase 1, Sector 33, Hisar, Haryana",
  whatsapp: "919468142444",
  phoneDisplay: "+91 94681 42444",
  phoneTel: "+919468142444",
  email: "laxmijiwanproperties@gmail.com",
  hours: "Mon – Sat · 9:30 AM – 8:00 PM   |   Sun · By Appointment",
};

export const waLink = (message) =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(message)}`;

export const mailLink = (subject = "Property Enquiry — Laxmi Jiwan Properties") =>
  `mailto:${BRAND.email}?subject=${encodeURIComponent(subject)}`;

export const telLink = `tel:${BRAND.phoneTel}`;

export const TEAM = [
  {
    id: "rajendar-sapra",
    name: "Rajender Sapra",
    role: "Founder & Managing Director",
    detail: "25+ Years — Residential, Commercial & Agricultural Land",
    bio: "A trusted name in Hisar property circles, guiding families and investors across residential, commercial and agricultural land — from clear-title acquisitions to high-value sales with complete transparency.",
  },
  {
    id: "ganga-ram-kukreja",
    name: "Ganga Ram Kukreja",
    role: "Property Rental Consultant",
    detail: "Residential Rental and Sales",
    bio: "A dedicated Residential Property Rental Consultant, helping Hisar families rent and let out homes with the right tenants, fair terms and complete paperwork support.",
  },
];

export const TESTIMONIALS = [
  { name: "Rampal", deal: "Purchase", text: "Sapra ji ne poori imaandari se plot dilwaya. Registry tak har step khud dekha. Bharosa ban gaya." },
  { name: "Jitender", deal: "Sale", text: "Sold my Sector 14 floor within weeks at a fair price. No hidden games, very transparent dealing." },
  { name: "Satpal", deal: "Rent", text: "Got a 2 BHK on rent quickly. The team understood exactly what my family needed. Highly recommend." },
  { name: "Naresh", deal: "Purchase", text: "Bought agricultural land near Barwala Road. They verified every document before I paid a rupee." },
  { name: "Suresh", deal: "Sale", text: "Sold my commercial shop through them. Genuine buyers, clear paperwork, and no unnecessary commission talk." },
  { name: "Mahesh", deal: "Purchase", text: "First time buying a builder floor. They explained everything patiently. Felt like dealing with family." },
  { name: "Dinesh", deal: "Rent", text: "Rented out my property with zero stress. They handled tenant verification and the agreement smoothly." },
  { name: "Rakesh", deal: "Purchase", text: "Sector 33 plot deal was completely hassle-free. Fair valuation and honest advice throughout." },
  { name: "Vinod", deal: "Sale", text: "Best property consultants in Hisar. Sold our farmhouse at the right value without any pressure." },
  { name: "Pawan", deal: "Rent", text: "Quick, professional and trustworthy. Found a commercial space on rent exactly in my budget." },
];

export const SERVICES = [
  {
    id: "plot",
    n: "01",
    title: "Residential & Commercial Plots",
    group: "Land",
    types: ["Sale", "Purchase", "Rent"],
    tag: "High Capital Growth",
    desc: "Prime sector land and gated-society plots across Sector 33, PLA Hisar and the Delhi Road corridor.",
    image:
      "https://images.unsplash.com/photo-1679364297777-1db77b6199be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjB2aWxsYSUyMGFyY2hpdGVjdHVyZSUyMGZhY2FkZSUyMG5pZ2h0JTIwd2FybSUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4ODMxNjE3NHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "builder_floor",
    n: "02",
    title: "Modern Builder Floors",
    group: "Residential",
    types: ["Sale", "Purchase", "Rent"],
    tag: "Luxury Living",
    desc: "Ready-to-move 3 & 4 BHK independent floors with premium finishes, stilt parking, lift access and clear titles.",
    image:
      "https://images.unsplash.com/photo-1748063578185-3d68121b11ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsdXh1cnklMjB2aWxsYSUyMGFyY2hpdGVjdHVyZSUyMGZhY2FkZSUyMG5pZ2h0JTIwd2FybSUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4ODMxNjE3NHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "farmhouse",
    n: "03",
    title: "Luxury Farmhouses & Estates",
    group: "Residential",
    types: ["Sale", "Purchase"],
    tag: "Exclusive Asset",
    desc: "Serene green farmhouses on the Hisar outskirts with wide access roads, power and water connections.",
    image:
      "https://images.unsplash.com/photo-1558645787-fbb262ceb47c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxncmVlbiUyMGFncmljdWx0dXJhbCUyMGZhcm1sYW5kJTIwY291bnRyeXNpZGUlMjBzdW5zZXR8ZW58MHx8fHwxNzg4MzE2MTc0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "commercial",
    n: "04",
    title: "Commercial Spaces & Outlets",
    group: "Commercial",
    types: ["Sale", "Purchase", "Rent"],
    tag: "High Yield Returns",
    desc: "High-footfall shops, showrooms and office floors in Hisar's busiest business and market hubs.",
    image:
      "https://images.unsplash.com/photo-1576731753569-3e93a228048c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwb2ZmaWNlJTIwYnVpbGRpbmclMjBhcmNoaXRlY3R1cmUlMjBnbGFzc3xlbnwwfHx8fDE3ODgzMTYxNzR8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "agriculture",
    n: "05",
    title: "Agricultural Land & Acres",
    group: "Land",
    types: ["Sale", "Purchase"],
    tag: "Heritage Investment",
    desc: "Clear-title farmland with canal water rights, highway frontage and long-term commercial potential.",
    image:
      "https://images.unsplash.com/photo-1546721435-666d5f9a5676?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxncmVlbiUyMGFncmljdWx0dXJhbCUyMGZhcm1sYW5kJTIwY291bnRyeXNpZGUlMjBzdW5zZXR8ZW58MHx8fHwxNzg4MzE2MTc0fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Transparency, Always",
    body: "Every deal begins with honest title verification and a clear registry trail. No hidden margins, no surprises at the sub-registrar.",
  },
  {
    n: "02",
    title: "Rooted in Hisar",
    body: "Decades of on-ground knowledge of Sector 33, PLA, Delhi Road and the wider Haryana market — we know these streets by heart.",
  },
  {
    n: "03",
    title: "Fair Market Value",
    body: "We price on facts, not on pressure. You get an honest valuation and the confidence that your investment is sound.",
  },
  {
    n: "04",
    title: "End-to-End Handholding",
    body: "From the first site visit to legal documentation and registry, our team stays beside you until the keys are in your hand.",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1624204386084-dd8c05e32226?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
